<template>
  <div class="mb-3">
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <h5 class="mb-3">Atividades</h5>
        </div>
      </div>
    </div>
    <Loader :loading="httpSend">
      <div class="row">
        <div class="col-md-12">
          <b-form-group label="Atividade" label-for="ser_codigo">
            <multiselect
                id="ser_codigo"
                v-model="temp_lista_servico"
                placeholder="Selecione as atividades"
                :custom-label="labelAtividade"
                track-by="ser_codigo"
                openDirection="bottom"
                :multiple="true"
                :options="servicos"
                :reset-after="true"
                :close-on-select="false"
                :max-height="600"
                @select="addServico"
                @remove="removerAtividadeSelect"
                :show-labels="false">
              <template slot="selection" slot-scope="{values}">
                <span class="multiselect__single" v-if="values.length && values.length < 2">{{ values.length }} atividade selecionada</span>
                <span class="multiselect__single" v-if="values.length && values.length > 1">{{ values.length }} atividades selecionadas</span>
              </template>
              <template slot="option" slot-scope="props">
                <div class="option__desc">
                  <span class="option__title">{{ props.option.ser_codigo }} - {{ props.option.ser_descricao }}</span>
                </div>
              </template>
            </multiselect>
            <h6 v-show="list_servicos && list_servicos.length < 1" class="text-danger">Necessário informar pelo menos
              uma atividade</h6>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="table-responsive">
            <table class="table mb-0">
              <thead>
              <tr>
                <th>Código</th>
                <th>Descrição</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(v, index) in list_servicos" v-bind:key="v.ser_codigo">
                <td>{{ v.ser_codigo }}</td>
                <td>{{ v.ser_descricao }}</td>
                <td class="text-right">
                  <button type="button" @click="removeAtividade(index)" class="btn btn-outline-danger btn-sm"><i
                      class="bx bxs-trash"></i></button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <h5 class="mb-3">Contador</h5>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <b-form-checkbox
              v-model="proprio_contador"
              :disabled="!habilida_proprio_contador"
              @change="proprioContador(contador.proprio_contador)"
              :value="true"
              :unchecked-value="false"
              class="custom-checkbox custom-checkbox-outline custom-checkbox-primary mb-3">
            Sou meu próprio contador <span v-show="!habilida_proprio_contador">(Necessário ter atividade 17.19)</span>
          </b-form-checkbox>
        </div>
      </div>
      <div v-if="!contador.proprio_contador" class="row">
        <div class="col-md-5">
          <label for="pes_cpfcnpj">CPF/CNPJ do Contador</label>
          <input v-model="contador.pes_cpfcnpj"
                 v-mask="(contador.pes_cpfcnpj && contador.pes_cpfcnpj.length < 15)?'###.###.###-##':'##.###.###/####-##'"
                 v-on:focusout="pesquisaContador(contador.pes_cpfcnpj)"
                 :class="{'is-invalid': contadorNaoExite}"
                 id="pes_cpfcnpj"
                 type="text"
                 class="form-control"/>
          <div v-show="contadorNaoExite" class="invalid-feedback">
            {{erroContador}}
          </div>
        </div>
        <div class="col-md-7">
          <label for="contador_nome">Nome/Razão Social</label>
          <input v-model="contador_pes_nome"
                 id="contador_nome"
                 type="text"
                 :disabled="true"
                 class="form-control"/>
        </div>
      </div>
    </Loader>
  </div>
</template>
<script>
import Multiselect from 'vue-multiselect'
import Loader from "@/components/widgets/loader";
import {autocompleteServicos} from "@/api/geral/autocomplete";
import {getContador} from "@/api/core/pessoa";

export default {
  components: {
    Loader,
    Multiselect
  },
  props: {
    list_servicos: {
      type: Array,
    },
    up_contador: {
      type: Object,
    },
  },
  data() {
    return {
      temp_lista_servico: [],
      temContador: false,
      contador: {
        pes_codigo: null,
        pes_nome: null,
        pes_cpfcnpj: null,
        pes_crc: null,
        proprio_contador: false
      },
      contadorNaoExite: false,
      erroContador: "Contador não encontrado",
      servicos: [],
      httpSend: false,
    };
  },
  computed: {
    habilida_proprio_contador: {
      get: function () {
        const servico = this.list_servicos.filter(s => s.ser_codigo === '17.19');
        return servico.length > 0;
      },
    },
    proprio_contador: {
      get: function () {
        if (this.up_contador.proprio_contador) {
          return this.up_contador.proprio_contador
        }
        return this.contador.proprio_contador;
      },
      set: function (newValue) {
        this.contador.proprio_contador = newValue;
      }
    },
    contador_pes_nome: {
      get: function () {
        if (this.up_contador.pes_nome) {
          return this.up_contador.pes_nome
        }
        return this.contador.pes_nome;
      },
      set: function (newValue) {
        this.contador.pes_nome = newValue;
      }
    },
    contador_pes_crc: {
      get: function () {
        if (this.up_contador.pes_crc) {
          return this.up_contador.pes_crc
        }
        return this.contador.pes_crc;
      },
      set: function (newValue) {
        this.contador.pes_crc = newValue;
      }
    },
  },
  created() {
    this.pesquisar('a')
  },
  methods: {
    pesquisar(search) {
      this.httpSend = true;
      autocompleteServicos({query: search}).then(response => {
        if (response.status) {
          this.servicos = response.dados;
        }
      }).catch(error => {
        console.log(error);
      }).finally(() => {
        this.httpSend = false;
      })
    },
    labelAtividade({ser_codigo, ser_descricao}) {
      return `${ser_codigo} - ${ser_descricao}`
    },
    addServico(selectedOption) {
      let index = this.list_servicos.findIndex(x => x.ser_codigo === selectedOption.ser_codigo)
      if (index < 0) {
        this.list_servicos.push(selectedOption)
      }
    },
    removerAtividadeSelect(removedOption) {
      let index = this.list_servicos.findIndex(x => x.ser_codigo === removedOption.ser_codigo)
      this.list_servicos.splice(index, 1);
    },
    removeAtividade(index) {
      this.list_servicos.splice(index, 1);
      this.temp_lista_servico = this.list_servicos;
    },
    proprioContador(value) {
      if (value) {
        this.contador.pes_codigo = null;
        this.contador.pes_cpfcnpj = null;
        this.contador.pes_nome = null;
        this.contador.pes_crc = null;
        this.contador.proprio_contador = value;
        this.up_contador.pes_codigo = null;
      }
      this.up_contador.proprio_contador = value
    },
    pesquisaContador(pes_cpfcnpj) {
      if (!pes_cpfcnpj) {
        return
      }
      if (pes_cpfcnpj.length < 11) {
        return
      }
      this.httpSend = true;
      getContador({pes_cpfcnpj: pes_cpfcnpj}).then(response => {
        this.contadorNaoExite = false;
        if (response.status) {
          this.contador.pes_codigo = response.dados.pes_codigo;
          this.contador.pes_nome = response.dados.pes_nome;
          this.contador.pes_crc = response.dados.pes_crc;
          this.up_contador.pes_codigo = response.dados.pes_codigo;
        } else {
          this.erroContador = response.mensagem;
          this.contadorNaoExite = true;
        }
      }).catch(error => {
        console.log(error);
      }).finally(() => {
        this.httpSend = false;
      })
    }
  }
};
</script>
<style>

input[type="text"][disabled] {
  background-color: #f6f6f9;
}

.option__title {
  word-wrap: break-word;
  white-space: normal;
}
</style>